import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const StyledDiv = styled.div`
  text-align: center;
  padding: ${SPACERS.large};
  svg {
    width: 52px;
    height: 52px;
    margin-top: ${SPACERS.medium};
    margin-bottom: ${SPACERS.small};
  }
  .message {
    margin-bottom: ${SPACERS.small};
  }
`;

interface NewReportCreatedProps {
  heading: string;
  subHeading?: {
    one: string;
    two?: string;
  };
}

const SuccessMessage: React.FC<NewReportCreatedProps> = ({
  heading,
  subHeading,
}) => {
  return (
    <StyledDiv>
      <FontAwesomeIcon icon={faCircleCheck} color={COLORS.success} />
      <TrueImpactText variant="body-bold" className="message">
        {heading}
      </TrueImpactText>
      {subHeading && (
        <TrueImpactText>
          {subHeading.one}
          {subHeading.two && <br />}
          {subHeading.two}
        </TrueImpactText>
      )}
    </StyledDiv>
  );
};

export default SuccessMessage;
